import { Eula } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const getEula = () => HttpClient.get<Eula>(API_FACTORY.v1('users/eula'));
